import React, { useState} from 'react';
import '../view-archer-styles.css';

// material-ui
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, FormControl, MenuItem, InputLabel,Select, TextField, Typography } from '@mui/material/';
import { blue} from '@mui/material/colors';

//components import
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';

interface NewRecipientProps {
    letterId: number,
    isNewRecipientDialogOpen: boolean,
    closeNewRecipientDialog: (isNewRecipientAdded: boolean) => void
}

const NewLetterRecipientDialog = (props: NewRecipientProps) => {

    //initial state set up
    const [recipientSalutation, setRecipientSalutation] = useState("");
    //initial payload
    const updateRecipientSalutation = (event: any) => {
        setRecipientSalutation(event.target.value);
    };
    const addNewRecipient = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formData as any).entries());
        const recipientFirstName = formJson.recipientFirstName;
        const recipientLastName = formJson.recipientLastName;
        const recipientEmailAddress = formJson.recipientEmailAddress;

        var params = [
            `letterId=${props.letterId}`,
            `salutation=${recipientSalutation}`,
            `firstName=${recipientFirstName}`,
            `lastName=${recipientLastName}`,
            `emailAddress=${recipientEmailAddress}`
        ].join('&');

        //maybe update to use post
        let url = `/Archer3/SetPrimaryLetterRecipient?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: SaveLegalReferral',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    props.closeNewRecipientDialog(true);
                }
            })
    }


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <>
            <Dialog
                open={props.isNewRecipientDialogOpen}
                onClose={props.closeNewRecipientDialog}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => addNewRecipient(event)
                }}
            >
                <DialogTitle>
                    <Typography sx={{ color: blue[800] }}>Add a New Primary Recipient</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Salutation</InputLabel>
                                <Select
                                    label="Salutation"
                                    name="recipientSaluation"
                                    onChange={(event) => { updateRecipientSalutation(event) }}
                                >
                                    <MenuItem value={"Mr."}>Mr.</MenuItem>
                                    <MenuItem value={"Ms."}>Ms.</MenuItem>
                                    <MenuItem value={"Mx."}>Mx.</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                margin="dense"
                                name="recipientFirstName"
                                label="Recipient First Name"
                                fullWidth
                                size="small"
                                required
                            />
                            <TextField
                                margin="dense"
                                name="recipientLastName"
                                label="Recipient Last Name"
                                fullWidth
                                size="small"
                                required
                            />

                            <TextField
                                margin="dense"
                                name="recipientEmailAddress"
                                label="Recipient Email Address"
                                fullWidth
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>props.closeNewRecipientDialog(false)}>Cancel</Button>
                    <Button type="submit">Save</Button>
                </DialogActions>
            </Dialog>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )
}

export default NewLetterRecipientDialog;